import { authHeader } from '../_helpers';

export const queryService = {
    getAll,
		updateQuery,
		addQuery,
		deleteQuery,
		activateQuery,
		deactivateQuery,
		getActive,
		getInactive
};

const baseDomain = process.env.REACT_APP_DATA_SUBDOMAIN + "." + process.env.REACT_APP_DOMAIN;
const baseUrl = "https://" + baseDomain + "/query/";

function getAll(token, sport) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(token)
    };

    return fetch(baseUrl + sport, requestOptions).then(handleResponse);
}

function getActive(token, sport) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(token)
    };

    return fetch(baseUrl + sport + "?active=1", requestOptions).then(handleResponse);
}

function getInactive(token, sport) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(token)
    };

    return fetch(baseUrl + sport + "?active=0", requestOptions).then(handleResponse);
}


function updateQuery(token, sport, oldQuery, newQuery) {
		this.deactivateQuery(token, sport, oldQuery);
		return this.addQuery(token, sport, newQuery);
}

function deactivateQuery(token, sport, query) {
    const requestOptions = {
        method: 'PUT',
				headers: { ...authHeader(token), 'Content-Type': 'application/json' },
				body: JSON.stringify({"query": query, "active": 0, "primary": 1})
    };

    return fetch(baseUrl + sport, requestOptions).then(handleResponse);
}

function activateQuery(token, sport, query) {
    const requestOptions = {
        method: 'PUT',
				headers: { ...authHeader(token), 'Content-Type': 'application/json' },
				body: JSON.stringify({"query": query, "active": 1, "primary": 1})
    };

    return fetch(baseUrl + sport, requestOptions).then(handleResponse);
}

function addQuery(token, sport, query) {
    const requestOptions = {
        method: 'POST',
				headers: { ...authHeader(token), 'Content-Type': 'application/json' },
				body: JSON.stringify({"query": query})
    };

    return fetch(baseUrl + sport, requestOptions).then(handleResponse);
}

function deleteQuery(token, sport, query) {
    const requestOptions = {
        method: 'DELETE',
				headers: { ...authHeader(token), 'Content-Type': 'application/json' },
				body: JSON.stringify({"query": query})
    };

    return fetch(baseUrl + sport, requestOptions).then(handleResponse);
}

function handleResponse(response) {
    if (!response.ok) { 
        return Promise.reject(response.statusText);
    }

    return response.json();
}



// WEBPACK FOOTER //
// ./src/_services/queries.js